// AlgoliaQuickSearch — header autocomplete using autocomplete.js v0.36
import $ from 'jquery';
import { polyfillInitIndex } from '../search/algolia_compat';

// autocomplete.js v0.36 via `immediate` dependency needs `global` shimmed.
// The shim lives in app_bundle.js (before any imports).
import autocomplete from 'autocomplete.js';


window.AlgoliaQuickSearch = {
  initialize(app_id, api_key, secured_api_key, project_index_name, company_index_name, company_widget_index_name, workplace_phase_index_name, workplace_tender_index_name, cloud_name) {
    if (!autocomplete) { console.warn('[AlgoliaQuickSearch] autocomplete.js not available — check global shim'); return; }
    let myProjects, myProjectsSource, myTenders, myTendersSource;
    const client = algoliasearch(app_id, api_key);
    polyfillInitIndex(client);
    const projects = client.initIndex(project_index_name);
    const companies = client.initIndex(company_index_name);
    const products = client.initIndex(company_widget_index_name);

    if (secured_api_key) {
      const securedClient = algoliasearch(app_id, secured_api_key);
      polyfillInitIndex(securedClient);
      myProjects = securedClient.initIndex(workplace_phase_index_name);
      myTenders = securedClient.initIndex(workplace_tender_index_name);
    }

    const templateCompany = _.template(`
      <div class="companies">
      <a href="/companies/<%= data.slug %>" class="result-name">
      <div class="result-img">
      <img src="https://res.cloudinary.com/<%= data.cloud_name %>/image/upload/w_90,h_90,dpr_2.0,q_auto:eco,c_fit/<%= data.logo_public_id %>"/>
      </div>
      <div><%= data._highlightResult.name_with_alias.value %></div>
      <div class="result-details">
      <% if(data.displaying_address.label) { %>
      <%= data.displaying_address.label %> -
      <% } %>
      <% if(data.category) { %>
      <%= data.category %> -
      <% } %>
      <%= data.projects_count %> projects
      </div>
      </a>
      </div>`, { variable: 'data' });

    const templateProject = _.template(`\
      <div class="projects">
      <a href="/projects/<%= data.slug %>" class="result-name">
      <div class="result-img">
      <img src="https://res.cloudinary.com/<%= data.cloud_name %>/image/upload/w_90,h_90,dpr_2.0,q_auto:eco,c_fill,g_auto/<%= data.photo_public_id %>"/>
      </div>
      <div><%= data._highlightResult.title.value %></div>
      <div class="result-details"><%= data.sectors.join(', ') %> - <%= data.awarded_participants_count %> participants </div>
      </a>
      </div>`, { variable: 'data' });

    const templateProduct = _.template(`\
      <div class="products">
      <a href="/products/<%= data.slug %>" class="result-name">
      <div class="result-img">
      <img src="https://res.cloudinary.com/<%= data.cloud_name %>/image/upload/w_90,h_90,dpr_2.0,q_auto:eco,c_fill,g_auto/<%= data.photo_public_id %>"/>
      </div>
      <div><%= data._highlightResult.title.value %></div>
      <div class="result-details"><%= data.category %> by <%= data.manufacturer %></div>
      </a>
      </div>`, { variable: 'data' });

    const templateMyTender = _.template(`\
      <div class="my-tenders">
      <a href="/workplace/tenders/<%= data.id %>" class="result-name">
      <div class="result-img">
      <img src="https://res.cloudinary.com/<%= data.cloud_name %>/image/upload/w_90,h_90,dpr_2.0,q_auto:eco,c_fill,g_auto/<%= data.photo_public_id %>"/>
      </div>
      <div><%= data._highlightResult.name.value %></div>
      <div class="result-details">Ref: <%=data.reference%> - <%= data.formatted_state %></div>
      </a>
      </div>`, { variable: 'data' });

    const templateMyProject = _.template(`\
      <div class="my-projects">
      <a href="/workplace/projects/<%= data.project_slug %>/phases/<%= data.phase_slug %>" class="result-name">
      <div class="result-img">
      <img src="https://res.cloudinary.com/<%= data.cloud_name %>/image/upload/w_90,h_90,dpr_2.0,q_auto:eco,c_fill,g_auto/<%= data.photo_public_id %>"/>
      </div>
      <div><%= data._highlightResult.title.value %></div>
      <div class="result-details">Ref: <%=data.reference%> - <%= data.phase %></div>
      </a>
      </div>`, { variable: 'data' });

    const companiesSource = {
      source: autocomplete.sources.hits(companies, { hitsPerPage: 3, restrictSearchableAttributes: ['name_with_alias'], filters: 'demo=0' }),
      displayKey: 'name_with_alias',
      name: 'companies',
      templates: {
        header(data, algoliaResponse) {
          const totalHits = algoliaResponse.nbHits;
          const viewAll = totalHits > "3" ? `<a class='small-text right' href='/companies?query=${data.query}'>View all</a>` : "";
          return "<div class=\"category\">" + viewAll + `${`Companies (${algoliaResponse.hits.length} of ${algoliaResponse.nbHits})`}</div>`;
        },
        suggestion(hit) {
          const data = _.extend(hit, { cloud_name });
          if (data.displaying_address.label) { data.displaying_address.label = data.displaying_address.label.split(' - ').pop(); }
          return templateCompany(data);
        }
      }
    };

    const projectsSource = {
      source: autocomplete.sources.hits(projects, { hitsPerPage: 3, restrictSearchableAttributes: ['title', 'plot_number', 'alias'], filters: 'is_verified=1 AND demo=0' }),
      displayKey: 'title',
      name: 'projects',
      templates: {
        header(data, algoliaResponse) {
          const totalHits = algoliaResponse.nbHits;
          const viewAll = totalHits > 3 ? `<a class='small-text right' href='/projects?query=${data.query}'>View all</a>` : "";
          return "<div class=\"category\">" + viewAll + `${`Projects (${algoliaResponse.hits.length} of ${algoliaResponse.nbHits})`}</div>`;
        },
        suggestion(hit) { return templateProject(_.extend(hit, { cloud_name })); }
      }
    };

    const productsSource = {
      source: autocomplete.sources.hits(products, { hitsPerPage: 3, restrictSearchableAttributes: ['title'], filters: 'state:approved' }),
      displayKey: 'title',
      name: 'products',
      templates: {
        header(data, algoliaResponse) {
          const totalHits = algoliaResponse.nbHits;
          const viewAll = totalHits > 3 ? `<a class='small-text right' href='/products?query=${data.query}'>View all</a>` : "";
          return "<div class=\"category\">" + viewAll + `${`Products (${algoliaResponse.hits.length} of ${algoliaResponse.nbHits})`}</div>`;
        },
        suggestion(hit) { return templateProduct(_.extend(hit, { cloud_name })); }
      }
    };

    if (secured_api_key) {
      myProjectsSource = {
        source: autocomplete.sources.hits(myProjects, { hitsPerPage: 3 }),
        displayKey: 'name',
        name: 'myProjects',
        templates: {
          header(data, algoliaResponse) {
            const totalHits = algoliaResponse.nbHits;
            const viewAll = totalHits > 3 ? `<a class='small-text right' href='/workplace/projects?query=${data.query}'>View all</a>` : "";
            return "<div class=\"category\">" + viewAll + `${`My Projects (${algoliaResponse.hits.length} of ${algoliaResponse.nbHits})`}</div>`;
          },
          suggestion(hit) { return templateMyProject(_.extend(hit, { cloud_name })); }
        }
      };

      myTendersSource = {
        source: autocomplete.sources.hits(myTenders, { hitsPerPage: 3 }),
        displayKey: 'name',
        name: 'myTenders',
        templates: {
          header(data, algoliaResponse) {
            const totalHits = algoliaResponse.nbHits;
            const viewAll = totalHits > 3 ? `<a class='small-text right' href='/workplace/tenders?query=${data.query}'>View all</a>` : "";
            return "<div class=\"category\">" + viewAll + `${`My Tenders (${algoliaResponse.hits.length} of ${algoliaResponse.nbHits})`}</div>`;
          },
          suggestion(hit) { return templateMyTender(_.extend(hit, { cloud_name })); }
        }
      };
    }

    const sources = secured_api_key ? [myProjectsSource, myTendersSource] : [];
    sources.push(companiesSource, projectsSource, productsSource);

    return autocomplete('#search-input', { hint: false }, sources).on('autocomplete:selected', function (event, suggestion, dataset) {
      rudderanalytics.track('Quick Search', { clicked_on: '/' + dataset + '/' + suggestion.slug });
      event.preventDefault();
      return location.href = '/' + dataset + '/' + suggestion.slug;
    });
  }

};

// algolia quick search events
$(document).on('focus', 'div.algolia-autocomplete input[type="search"]', function () {
  $('.sbx-custom__wrapper').toggleClass('is-active', true)
})

$(document).on('blur', 'div.algolia-autocomplete input[type="search"]', function () {
  $('.sbx-custom__wrapper').toggleClass('is-active', false)
})

$(document).on('keyup change paste', 'div.algolia-autocomplete input[type="search"]', function () {
  $('.sbx-custom__wrapper').toggleClass('is-valid', $(this).val().length > 0)
})
